import { ModuleWithProviders } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import {NotFoundComponent} from "./features/components/not-found/not-found.component";
/**
 * Created by mohit on 07-05-2017.
 */
// const cons = new Constants();
const router: Routes = [
  { path: '', loadChildren: () => import('./features/features.module').then(m => m.FeaturesModule), },
  { path: '', loadChildren: () => import('./affiliate/affiliate.module').then(m => m.AffiliateModule) },
  { path: '**', component: NotFoundComponent },

];


export const routing: ModuleWithProviders<any> = RouterModule.forRoot(router);
